import { Link } from '@tanstack/react-router'
import { AlertCircleIcon, HomeIcon, LifeBuoyIcon } from 'lucide-react'

import { Button } from '@/components/ui'
import { useSupportTicket } from '@/modules/support'
import { isProjectStatus } from '../status'
import type { Project } from '../stores'

interface ProjectAssemblyFailedProps {
  project: Project
}

export const ProjectAssemblyFailed = ({
  project,
}: ProjectAssemblyFailedProps) => {
  const { openTicket } = useSupportTicket()
  const failedDuplicating = isProjectStatus(project, 'duplicateFailed')

  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center gap-4 rounded-lg border border-red-200 bg-white py-24 text-center"
    >
      <div className="rounded-full bg-red-50 p-4">
        <AlertCircleIcon className="size-8 text-red-500" />
      </div>
      <div className="space-y-1.5">
        <h3 className="text-lg font-semibold">
          {failedDuplicating
            ? "We couldn't copy this project"
            : "We couldn't combine these projects"}
        </h3>
        <p className="text-sm text-muted-foreground">
          {failedDuplicating
            ? 'Nothing was lost, the original project is untouched.'
            : 'Nothing was lost, the original projects are untouched.'}
        </p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button asChild theme="outline">
          <Link to="/projects">
            <HomeIcon className="size-4" />
            Back to projects
          </Link>
        </Button>
        <Button onClick={openTicket}>
          <LifeBuoyIcon className="size-4" />
          Get help
        </Button>
      </div>
    </div>
  )
}
